export class StringHelper {
    static camelCaseToSneakCase = (str) => {
        return str.replace(/[A-Z]/g, (letter, index) => {
            return index == 0 ? letter.toLowerCase() : '_' + letter.toLowerCase();
        });
    };
    static replace = (str) => {
        return str.replace(/([~!@#$%^&*()_+=`{}[\]|\\:;'<>,./? ])+/g, '-').replace(/^(-)+|(-)+$/g, '');
    };
    static getFullName = (user) => {
        if (user) {
            return `${user.firstName} ${user.lastName}`;
        }
        return '';
    };
    static getStatusBgStyles(status) {
        switch (status) {
            case 'active':
                return 'bg-emerald-600';
            case 'archived':
                return 'bg-amber-500';
            case 'draft':
            default:
                return 'bg-gray-500';
        }
    }
    static getStatusTextStyles(status) {
        switch (status) {
            case 'active':
                return 'text-emerald-600';
            case 'archived':
                return 'text-amber-500';
            case 'draft':
            default:
                return 'text-gray-500';
        }
    }
}
